export default "__VITE_ASSET__cLfud28Q__"